import React from "react";
import styled from 'styled-components'
import logo from '../../imgs/logowhatslabe.png'
import send2 from '../../imgs/send2.png'

const ContainerBox = styled.div `
  width: 350px;
  height:400px;
  margin: 50px auto;

  display: grid;
  grid-template-columns: 1fr ;
  grid-template-rows:60px 1fr 120px;

`

const Header = styled.div `
  background-color:#f4f4f4;
  padding: 20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;

    img{
      width:100px;
  }


`
const LogoCenter = styled.div`
  display: flex;
  justify-content: center;

  img{
    width:100px;
  }
`
const Main = styled.div `
  background-color:#f4f4f4;
  display: flex;
  flex-wrap:wrap;
  padding: 20px;

`
const Footer = styled.div `
  background-color:#a8bac5;

  border-bottom-right-radius: 20px;
  border-bottom-left-radius:  20px;
  display: flex;
  justify-content: center;
  align-items: center;

  button{
    padding: 6px  5px 2px  6px ;
    margin:0 10px 0 -10px ;
    background-color: #f8b14f;
    border-radius:10px;

    img{
      width: 20px;
     opacity: 0.8;
    }
  }
` 
const MyMessage = styled.p `
   background-color:#45525b;
  color: #f8b14f;
  margin-left:120px;
  border-radius:20px;
  width: 150px;
  min-height:20px;
  padding:  10px ;
  margin-right: 1px;
  align-self: end;
  font-size:12px;
  flex-wrap:wrap;
  text-align: start;
`

const YourMessage = styled.p `
   background-color:#a8bac5;
   color: #45525b;
   width: 150px;
   min-height:20px;
   font-size:12px;
   border-radius:20px;
  padding:  10px ;
  margin: 0 20px;
  align-self: start;
  flex-wrap:wrap;
    span{
      font-weight:800px;
    }
    text-align: start;
`


const InputsBox = styled.div `
  background-color:#a8bac5;
  border-radius: 20px;

`
const NameInput = styled.input `

background-color:orange;
 color: #191a19;
 border-radius: 8px;
 padding: 2px 35px;
 margin:5px;
`


const MessageInput = styled.input `

  background-color:#45525b;
  color: orange;
  border-radius: 20px;
  padding: 20px 40px;

`









export class Container extends React.Component {

  state = {
    name: "",
    messages: [],
    yourMessage: " ",
    show: false,

    userValue: '',
    messageValue: ''

  };



  onChangeUserValue = (event) => {
    this.setState({userValue: event.target.value})
  }

  onChangeMessageValue = (event) => {
    this.setState({ messageValue: event.target.value });
  };


  sendMessage = () => {
    const newMessage = {
      user: this.state.userValue,
      text: this.state.messageValue
    }

    const newMessages = [newMessage, ...this.state.messages]

    this.setState({messages: newMessages, })

    if (this.state.userValue == "eu") {
      return console.log("eu inserido")
    } else if (this.state.userValue ==  "Eu"){
      return console.log("Eu inserido")
    } else if (this.state.userValue ==  "EU"){
      return console.log("EU inserido")
    }

    
    
  };

  // clearInputs = () => {
  //   this.setState({ UserValue:'', messageValue: ""});
  //  };

  

    render(){

   
      
        return (
            <div>
         
              <ContainerBox>
                
                <Header> 
                  <LogoCenter>
                    <img src={logo} alt="logo labenu com escrito whatslabe ao lado" />
                  </LogoCenter>
                </Header>

          
                <Main> 

                {this.state.messages.reverse().map((message, index) => {
                     
                        if(message.user == "eu"){
                          return  <MyMessage> {message.text} </MyMessage>
                        }else if (message.user == "EU"){
                          return  <MyMessage> {message.text} </MyMessage>
                        }else if (message.user == "Eu"){
                          return  <MyMessage> {message.text} </MyMessage>
                        }    else  {
                          return  <YourMessage><strong>{message.user}: </strong> {message.text} </YourMessage>
                        }

                       
                   
                      })}
          
             
               </Main>




                <Footer> 

                  <InputsBox>

                    <NameInput
                      placeholder="Nome"
                     value={this.state.UserValue}
                      onChange={this.onChangeUserValue}
                      />

                    <MessageInput 
                    placeholder="Mensagem" 
                    value={this.state.MessageValue}
                    onChange={this.onChangeMessageValue}  />


                  </InputsBox>

                 

                  <button   onClick={this.sendMessage} > 

                    <img src="https://cdn-icons-png.flaticon.com/512/736/736212.png" alt="icone de avião de papel em preto"/>

                  </button>

                </Footer>


          

              </ContainerBox>
           
            </div>
          );

    }
    

  }
  
  export default Container;
  